import * as Yup from 'yup';

// eslint-disable-next-line func-names
Yup.addMethod(Yup.array, 'unique', function (message: string, mapper = (a: unknown) => a) {
  return this.test(
    'unique',
    message,
    (list = []) => list.length === new Set(list.map(mapper)).size,
  );
});

// eslint-disable-next-line func-names
Yup.addMethod(Yup.string, 'emailsSeparated', function (errorMessage) {
  return this.test('emailsSeparated', errorMessage, (value) => {
    // push email into emails array
    const emails = value.replace(/\s/g, '').split(',');
    const emailSchema = Yup.string().email();
    return emails.every((email: string) => emailSchema.isValidSync(email));
  });
});
